// Shared helpers for the WebAuthn Stimulus controllers: the API speaks
// ArrayBuffers, the server speaks base64url.

export function base64urlToBuffer(base64url) {
  const base64 = base64url.replace(/-/g, "+").replace(/_/g, "/")
  const padding = "=".repeat((4 - (base64.length % 4)) % 4)
  const binary = atob(base64 + padding)
  return Uint8Array.from(binary, (char) => char.charCodeAt(0)).buffer
}

export function bufferToBase64url(buffer) {
  const bytes = new Uint8Array(buffer)
  const binary = Array.from(bytes, (byte) => String.fromCharCode(byte)).join("")
  return btoa(binary).replace(/\+/g, "-").replace(/\//g, "_").replace(/=+$/, "")
}

export function csrfHeaders() {
  return {
    "Content-Type": "application/json",
    "Accept": "application/json",
    "X-CSRF-Token": document.querySelector('meta[name="csrf-token"]')?.content || ""
  }
}
